import type { SagaIterator } from 'redux-saga';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { replaceAsset, uploadAssets } from '../asset-uploader';
import { deleteContent } from '../content';
import { waitForIndexing } from '../content/saga/persistence';
import { type ContentSearchState, getSearchState, search } from '../content-search';
import { deleteSelected, deleteSelectedPending, toggleAll, toggleAllFulfilled } from './actions';
import { LIBRARY_SEARCH_NAME, SHAPE_ID } from './constants';
import type { AssetsState } from './reducer';
import { getState } from './selectors';

export function* searchAssetsSaga(): SagaIterator {
  yield call(waitForIndexing, SHAPE_ID);
  yield put(
    search.requested({ searchName: LIBRARY_SEARCH_NAME })({
      shapeIds: [SHAPE_ID]
    })
  );
}

export function* deleteSelectedSaga(): SagaIterator {
  const state: AssetsState = yield select(getState);
  yield put(deleteSelectedPending());
  yield all(
    state.selected.map((id) =>
      put(
        deleteContent.requested(undefined, {
          contentId: id,
          shapeId: SHAPE_ID,
          locale: ''
        })
      )
    )
  );
}

export function* toggleAllSaga(): SagaIterator {
  const searchState: ContentSearchState = yield select(getSearchState, {
    searchName: LIBRARY_SEARCH_NAME
  });
  yield put(toggleAllFulfilled(searchState.results.map((result) => result._id)));
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(deleteSelected, deleteSelectedSaga),
    takeLatest(uploadAssets.FULFILLED, searchAssetsSaga),
    takeLatest(replaceAsset.FULFILLED, searchAssetsSaga),
    takeLatest(toggleAll, toggleAllSaga)
  ]);
}
